var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"caseWrapper",staticClass:"templates-wrapper"},[_c('Content0',{attrs:{"id":"Content0_0","is-mobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }